<template>
  <div>
    <LmsDriveTable />
  </div>
</template>
<script>
import LmsDriveTable from '@/views/Lmsmanagement/Components/Lmsdrivelinktable'

export default {
  components: {
    LmsDriveTable,
  },
}
</script>
